import { Section, stagger, slug } from "./Section";

const AREAS = [
  {
    n: "01",
    title: "Project Development & Site Advisory",
    desc: "Early-stage support to identify project constraints and development risks before major commitments are made.",
    vp: "We help clients identify project constraints and development risks before major commitments are made.",
    bg: "#FFFFFF",
    items: [
      "Site reconnaissance and preliminary site assessment",
      "Development and constructability risk review",
      "Access and logistics assessment",
      "Coordination of surveys and specialist investigations",
      "Local project and stakeholder interfaces",
      "Early-stage project risk assessment",
    ],
  },
  {
    n: "02",
    title: "Project Delivery & Assurance",
    desc: "Our principal area of work.",
    vp: "We help owners maintain a clear view of project progress, quality, risks and actions requiring attention.",
    bg: "#F0F4FF",
    items: [
      "Owner's Engineer",
      "Construction and project monitoring",
      "Site supervision",
      "QA/QC and construction assurance",
      "Project controls and progress review",
      "Contractor and interface monitoring",
      "Testing and commissioning oversight",
      "Completion and close-out support",
      "Project health and recovery reviews",
    ],
  },
  {
    n: "03",
    title: "Energy & Asset Solutions",
    desc: "Selected services complementing our project-delivery work.",
    vp: "We bring the same discipline and rigour we apply to project delivery to the management and improvement of operating assets.",
    bg: "#FFFFFF",
    items: [
      "BESS project development and implementation",
      "BESS monitoring QA/QC and commissioning",
      "Distributed-energy project support",
      "Technical inspections",
      "Selected asset-performance and operational support",
      "Technology and solution partnerships where we can provide credible local implementation and support",
    ],
  },
];

const Area = ({ a, i }) => {
  const s = slug(a.title);
  return (
    <div id={s} className="service-band scroll-mt-24" style={{ backgroundColor: a.bg }} data-testid={`service-band-${a.n}`}>
      <article className="als-container reveal-item grid gap-8 py-14 lg:grid-cols-[0.4fr_0.6fr] lg:gap-16 lg:py-16" style={stagger(i)} data-testid={`service-area-${s}`}>
        <div className="relative">
          <span className="ghost-number" aria-hidden="true">{a.n}</span>
          <h3 className="relative text-[16px] font-medium leading-snug text-[#1B3A6B]" data-testid={`service-area-heading-${s}`}>{a.title}</h3>
          <p className="mt-4 text-[15px] leading-[1.7] text-[#4A5568]">{a.desc}</p>
          <p className="mt-4 border-l-2 border-[#1B3A6B] pl-4 text-[15px] font-medium leading-[1.7] text-[#1B3A6B]" data-testid={`service-area-vp-${s}`}>{a.vp}</p>
        </div>
        <ul className="grid content-start gap-x-8 gap-y-3 text-[15px] leading-[1.6] text-[#4A5568] sm:grid-cols-2" data-testid={`service-area-bullets-${s}`}>
          {a.items.map((it) => (
            <li key={it} className="border-b border-[#1B3A6B]/15 pb-3">{it}</li>
          ))}
        </ul>
      </article>
    </div>
  );
};

export const Services = () => (
  <Section id="what-we-do" className="bg-white !pb-0" testId="what-we-do-section" bare>
    <div className="als-container">
      <h2 className="als-heading is-centered text-center" data-testid="section-heading-what-we-do">Three areas of work</h2>
    </div>
    <div className="mt-8">
      {AREAS.map((a, i) => <Area key={a.n} a={a} i={i} />)}
    </div>
  </Section>
);
